'use strict';

var EditWifiGlobal = require('actionGroups/wifiGlobal/WifiGlobal');

module.exports = {
  Model: EditWifiGlobal,
};
